import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { ApiService } from '@core/http/api.service';
import type { AuthSessionResponse, VerifyEmailOtpResponse } from '@shared/models/auth.model';

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  private readonly api = inject(ApiService);

  sendEmailOtp(email: string): Observable<void> {
    return this.api.postNoContent('/auth/otp/email/send', { email });
  }

  verifyEmailOtp(email: string, code: string): Observable<VerifyEmailOtpResponse> {
    return this.api.post<VerifyEmailOtpResponse>('/auth/otp/email/verify', { email, code });
  }

  getMe(): Observable<AuthSessionResponse> {
    return this.api.get<AuthSessionResponse>('/auth/me');
  }

  logout(): Observable<void> {
    return this.api.postNoContent('/auth/logout');
  }
}
